import React from 'react';
import type { CellRenderProps } from '@axiom/ui';
import { Link } from 'react-router';

import type { CandidateDetail } from '../../api/chat-api';
import { CandidateAvailabilityModalStore } from '../../../stores/candidate-availability-modal-store';
import { MatchGridUtil } from '../../utils/match-grid-util';

/**
 * When a candidate is free, opening the availability modal rather than navigating.
 *
 * **A `Link` to `#` with the navigation cancelled**, so the cell reads and behaves as a link while
 * the click opens a modal - the profile is not where this goes.
 */
export const MatchGridAvailability = ({
  data,
}: CellRenderProps<CandidateDetail>) => {
  const availability = data.availability ?? MatchGridUtil.NOT_YET;

  if (!data.id) return availability;

  return (
    <Link
      data-test={`AVAILABILITY_${data.id}`}
      onClick={event => {
        event.preventDefault();
        void CandidateAvailabilityModalStore.openModal(data.id);
      }}
      to="#"
      rel="noopener noreferrer"
    >
      {availability}
    </Link>
  );
};
